import { useDispatch, useSelector } from "react-redux";
import { loadMessageHistory, setNewMessageReceived } from "../../../../store/slices/chatSlice";
import Message from "./Message";
import { useEffect, useRef, useState } from "react";
import PageLoader from "../../../../components/Loader/PageLoader";

const MessagesBox = () => {
    const dispatch = useDispatch();
    const { messages, filteredMessages, isLoading, isSearching, newMessageReceived, pinnedMessage } = useSelector((state) => state.chat);
    const { hasMore } = useSelector((state) => state.chat.meta);

    const messagesContainerRef = useRef(null);
    const [firstLoad, setFirstLoad] = useState(true);
    const [prevScrollHeight, setPrevScrollHeight] = useState(0);

    useEffect(() => {
        dispatch(loadMessageHistory());
    }, [dispatch]);

    useEffect(() => {
        if (firstLoad && messages.length > 0) {
            setTimeout(() => {
                if (messagesContainerRef.current) {
                    messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
                }
            }, 100);
            setFirstLoad(false);
        }
    }, [messages, firstLoad, pinnedMessage]);

    useEffect(() => {
        if (!firstLoad && messagesContainerRef.current) {
            const container = messagesContainerRef.current;
            container.scrollTop = container.scrollHeight - prevScrollHeight;
        }
    }, [messages]);

    useEffect(() => {
        if (newMessageReceived && messagesContainerRef.current) {
            const container = messagesContainerRef.current;
            if (newMessageReceived) {
                container.scrollTop = container.scrollHeight;
            }
            dispatch(setNewMessageReceived(false)); 
        }
    }, [newMessageReceived, dispatch]);

    const handleScroll = () => {
  if (messagesContainerRef.current) {
    const { scrollTop, scrollHeight } = messagesContainerRef.current;

    if (scrollTop === 0 && !isLoading && hasMore && !isSearching) {
      setPrevScrollHeight(scrollHeight);
      dispatch(loadMessageHistory());
    }
  }
};


    return (
        <div
            ref={messagesContainerRef}
            id="search-scroll-chat"
            className="chat-box"
            onScroll={handleScroll}
            style={{ overflowY: "auto", position: "relative" }}
        >
            {isLoading && (
                    <PageLoader />
                )}
            {filteredMessages.map((msg, index) => (
                <Message key={index} msg={msg} pinnedMessage={pinnedMessage} />
            ))}
        </div>
    );
};

export default MessagesBox;
